import { render, staticRenderFns } from "./IntegrationCodeSnippet.vue?vue&type=template&id=90f987a2&scoped=true&"
import script from "./IntegrationCodeSnippet.vue?vue&type=script&lang=js&"
export * from "./IntegrationCodeSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f987a2",
  null
  
)

export default component.exports